import { render, staticRenderFns } from "./ChangeSettlementModel.vue?vue&type=template&id=61ca22e8&scoped=true"
import script from "./ChangeSettlementModel.vue?vue&type=script&lang=js"
export * from "./ChangeSettlementModel.vue?vue&type=script&lang=js"
import style0 from "./ChangeSettlementModel.vue?vue&type=style&index=0&id=61ca22e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ca22e8",
  null
  
)

export default component.exports